/**
 * IMPORTS
 */

// data / infra / repositories / users
import { PostCreateClientCompletRepositoryImplementation } from "@/data/infra/repositories/users/post-create-client-complet-repository-impl";
// domain / use-case / users
import { PostCreateClientCompletUseCase } from "@/domain/use-cases/users/post-create-client-complet-use-case";

function makePostCreateClientCompletUseCase() {
  const repository = new PostCreateClientCompletRepositoryImplementation();
  return new PostCreateClientCompletUseCase(repository);
}

/**
 * EXPORTS
 */
export { makePostCreateClientCompletUseCase };
